<template>
    <el-dialog
        title="作品管理"
        :visible.sync="dialogSign"
        width="1320px" :close-on-click-modal="false">
        <div class="orderListTable">
            <el-table
                height="520"
                :data="tableData"
                border
                style="width: 100%" class="tableContent">
                <el-table-column
                    prop="createTime"
                    label="报名时间"
                    header-align="center"
                    show-overflow-tooltip
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="username"
                    label="姓名"
                    header-align="center"
                    show-overflow-tooltip
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="tel"
                    align="center"
                    header-align="center"
                    label="账号">
                </el-table-column>
                <el-table-column
                    prop="signType"
                    align="center"
                    header-align="center"
                    label="参赛主体">
                    <template slot-scope="scope">
                        {{ scope.row.signType==='PERSONAL'?'个人':'团队' }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="teamName"
                    align="center"
                    header-align="center"
                    label="单位/院校">
                </el-table-column>
                <el-table-column
                    prop="teamMember"
                    align="center"
                    header-align="center"
                    label="团体成员">
                </el-table-column>
                <el-table-column
                    prop="name"
                    align="center"
                    header-align="center"
                    label="作品名称">
                </el-table-column>
                <el-table-column
                    prop="typeName"
                    align="center"
                    header-align="center"
                    label="作品类型">
                </el-table-column>
                <el-table-column
                    prop="statusCn"
                    align="center"
                    header-align="center"
                    label="审批状态">
                </el-table-column>
            </el-table>
            <el-pagination
                class="curren"
                background
                @current-change="handleCurrentChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :current-page="current"
                :page-size="pageSize"
                :total="total">
            </el-pagination>
        </div>
    </el-dialog>
</template>

<script>
import { getWorksList } from '../../../utils/interface';
export default {
    name: "signDialog",
    data() {
        return{
            dialogSign: false,
            current: 1,
            pageSize: 10,
            total: 0,
            activityUuid:'',
            tableData:[],
        }
    },
    methods: {
        init(type,uuid) {
            this.activityUuid = uuid;
            this.dialogSign = true;
            // 根据活动查询列表
            this.getWorksList();
        },
        getWorksList(){
            let params = {
                activityUuid:this.activityUuid,
            }
            getWorksList(params).then((res)=>{
                this.total = res.total;
                this.tableData = res.list;
            });
        },
        // 分页
        handleCurrentChange(val){
            this.current = val;
            this.getWorksList();
        },
    }
}
</script>

<style scoped lang="less">
    .dialogContent {
        padding: 0 5%;
        /deep/.el-upload-list--picture-card .el-upload-list__item{
            width: 590px;
            height: 300px;
        }
        /deep/.el-upload--picture-card{
            width: 590px;
            height: 300px;
            line-height: 300px;
        }
        /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail{
            width: 590px;
            height: 300px;
        }
        .titleTop {
          font-size: 20px;
          font-weight: bold;
          margin-bottom: 26px;
          margin-left: 48px;
        }
        .thumbnailClass{
            width: 590px;
            height: 300px;
            .avatar{
                width: 590px;
                height: 300px;
                border: 1px dashed #ddd;
                border-radius: 4px;
                line-height: 300px;
                font-size: 50px;
            }
        }
        .thumbnailClass2{
            width: 222px;
            height: 125px;
            margin-left: 16px;
            margin-bottom: 5px;
        }
        .thumbnailClass20{
            .avatar2{
                width: 222px;
                height: 125px;
                border: 1px dashed #ddd;
                border-radius: 4px;
                line-height: 125px;
                font-size: 50px;
                margin-left: 16px;
                p {
                  margin: 0;
                  font-size: 16px;
                }
            }
        }
        .endPeriodClass{
            /deep/.el-form-item__content{
                margin-left: 0 !important;
            }
        }
        .submitButtonClass{
            /deep/.el-form-item__content{
                margin-left: 0 !important;
                text-align: center;
                button{
                    padding: 0;
                    width: 120px;
                    height: 35px;
                    line-height: 35px;
                    border-radius: 6px;
                }
            }
        }
        .modelHeightRangeClass{
            display: flex;
            margin-bottom: 25px;
            /deep/.el-form-item__content{
                margin-left: 0 !important;
            }
        }
    }
    .successImgsUrl {
      cursor: pointer;
      color: #409EFF;
    }
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/activeDialog/workDialog.vue